import React, { useEffect, useState } from 'react';
import Plans from './Plans';
import './SubscriptionPage.scss';
import { Button, Link, Typography } from 'ui-kit';
import { message } from 'antd';
import useQuery from 'hooks/useQuery';
import PlanDetails from './PlanDetails';
import { AddOns } from './features';
import AddOnCard from './AddOnCard';

export default function SubscriptionPage() {
  const { status = '' } = useQuery<{ status: string }>();
  const [selectedInterval, setSelectedInterval] = useState<'month' | 'year'>('year');

  useEffect(() => {
    if (status === 'success') {
      message.info('Thank you for your purchase! You should receive a confirmation email shortly.');
    } else if (status === 'error') {
      message.error(
        'Something went wrong! We were unable to process your payment. Please try again.',
      );
    }
  }, []);

  const isMonthlySelected = selectedInterval === 'month';

  return (
    <>
      <div className="SubscriptionPageHeader">
        <Typography variant="h4">Pricing Plans</Typography>
        <Typography variant="subtitle1">Choose the plan that works for you.</Typography>
      </div>
      <div className="PlansContainer">
        <div className="PlansHeader">
          <Button
            variant={isMonthlySelected ? 'contained' : 'outlined'}
            color="primary"
            size="medium"
            onClick={() => setSelectedInterval('month')}
          >
            Pay Monthly
          </Button>
          <Button
            variant={isMonthlySelected ? 'outlined' : 'contained'}
            color="primary"
            size="medium"
            onClick={() => setSelectedInterval('year')}
          >
            Pay Yearly (save 20%)
          </Button>
        </div>
        <Plans interval={selectedInterval} />
      </div>
      <div className="SubscriptionPageDemo">
        <Typography variant="subtitle1">
          Got questions about our plans?&nbsp;
          <Link href="https://calendly.com/hostcodemo/host-co-demo">Book a demo.</Link>
        </Typography>
      </div>
      {/* FEATURE ADD-ONS */}
      <div className="AddOnsContainer">
        <div className="AddOnsHeader">
          <Typography variant="h4">Add-on Features</Typography>
          <Typography variant="subtitle1">
            Want to add Enterprise-level features on any plan? Access our premium add-ons here.
          </Typography>
        </div>

        <div className="AddOnsBody">
          <div className="AddOnsHeader_mobile">
            <Typography variant="h4">Add-on Features</Typography>
            <Typography variant="subtitle1">
              Want to add Enterprise-level features on any plan? Access our premium add-ons here.
            </Typography>
          </div>
          {AddOns.map((addOn, index) => (
            <AddOnCard key={index} addOn={addOn} />
          ))}
        </div>
      </div>
      <div className="SubscriptionPageFeatures" id="features">
        <Typography variant="h4">Compare our plans to see which is best for you.</Typography>
        <PlanDetails />
      </div>
    </>
  );
}
